import { useCallback } from 'react';
import { IHandleSetInputParams, TInputState } from '../types';
import { THandleSetInput } from './types';

export const useHandleSetInput = ({
  inputs,
  setInputs,
}: IHandleSetInputParams): THandleSetInput => {
  return useCallback(
    (name: string, input: TInputState) => {
      const newInputs = { ...inputs, [name]: input };
      setInputs(newInputs);
    },
    [inputs, setInputs]
  );
};
